<img [class.avatar-rounded]="rounded" [width]="size" [height]="size" [src]="src" alt="" draggable="false">